import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import {
  getSize,
  getInOfficeHeadcountBasedQuantites,
  getFixedQuantities,
  getInOfficeHeadcountBasedQuantitesWithAddition,
} from './utils';

export const serviceareas = [
  {
    id: 20,
    name: 'spaceTypes.serviceAreas.smallStorage',
    displayOrder: 1,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(10.0, 10.0),
      [countries.UK]: getSize(10.0, 10.0),
      [countries.FR]: getSize(2.2, 2.2),
      [countries.EU]: getSize(3.0, 3.0),
      [countries.DE]: getSize(3.0, 3.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818117/insite/qa/spaces/quffe8izbjrol7whbdmk.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818117/insite/qa/spaces/quffe8izbjrol7whbdmk.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818117/insite/qa/spaces/quffe8izbjrol7whbdmk.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818117/insite/qa/spaces/quffe8izbjrol7whbdmk.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818117/insite/qa/spaces/quffe8izbjrol7whbdmk.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 21,
    name: 'spaceTypes.serviceAreas.mediumStorage',
    displayOrder: 2,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(2.7, 4.0),
      [countries.EU]: getSize(3.0, 4.0),
      [countries.DE]: getSize(3.0, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818118/insite/qa/spaces/rkqqw8zoz70vkgxvodi9.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818118/insite/qa/spaces/rkqqw8zoz70vkgxvodi9.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818118/insite/qa/spaces/rkqqw8zoz70vkgxvodi9.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818118/insite/qa/spaces/rkqqw8zoz70vkgxvodi9.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818118/insite/qa/spaces/rkqqw8zoz70vkgxvodi9.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 22,
    name: 'spaceTypes.serviceAreas.largeStorage',
    displayOrder: 3,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(15.0, 12.0),
      [countries.UK]: getSize(15.0, 12.0),
      [countries.FR]: getSize(2.7, 5.2),
      [countries.EU]: getSize(3.0, 5.0),
      [countries.DE]: getSize(3.0, 5.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818120/insite/qa/spaces/bnws9pkz9zihygd7vkj2.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818120/insite/qa/spaces/bnws9pkz9zihygd7vkj2.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818120/insite/qa/spaces/bnws9pkz9zihygd7vkj2.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818120/insite/qa/spaces/bnws9pkz9zihygd7vkj2.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818120/insite/qa/spaces/bnws9pkz9zihygd7vkj2.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 87,
    name: 'spaceTypes.serviceAreas.copyGalleyStyle',
    displayOrder: 4,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(10.0, 6.0),
      [countries.UK]: getSize(10.0, 6.0),
      [countries.FR]: getSize(2.0, 3.0),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818129/insite/qa/spaces/reddi70bmha9s3kue2vk.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818129/insite/qa/spaces/reddi70bmha9s3kue2vk.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818129/insite/qa/spaces/reddi70bmha9s3kue2vk.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818129/insite/qa/spaces/reddi70bmha9s3kue2vk.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818129/insite/qa/spaces/reddi70bmha9s3kue2vk.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 69,
    name: 'spaceTypes.serviceAreas.ITComputerRoom',
    displayOrder: 5,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(15.0, 10.0),
      [countries.UK]: getSize(15.0, 10.0),
      [countries.FR]: getSize(4.05, 5.2),
      [countries.EU]: getSize(5.0, 6.0),
      [countries.DE]: getSize(5.0, 6.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(1),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(1),
      [countries.EU]: getFixedQuantities(1),
      [countries.DE]: getFixedQuantities(1),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818123/insite/qa/spaces/d7m3d9irqs9mc0kwn3uz.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818123/insite/qa/spaces/d7m3d9irqs9mc0kwn3uz.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818123/insite/qa/spaces/d7m3d9irqs9mc0kwn3uz.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818123/insite/qa/spaces/d7m3d9irqs9mc0kwn3uz.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818123/insite/qa/spaces/d7m3d9irqs9mc0kwn3uz.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 70,
    name: 'spaceTypes.serviceAreas.wellnessMothers',
    displayOrder: 6,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(4.05, 5.2),
      [countries.EU]: getSize(3.5, 4.0),
      [countries.DE]: getSize(3.5, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.UK]: getInOfficeHeadcountBasedQuantitesWithAddition(150, 150, 150, 1),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(100, 100, 100),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818125/insite/qa/spaces/cpgp1otrhrdm4hnytlv6.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818125/insite/qa/spaces/cpgp1otrhrdm4hnytlv6.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818125/insite/qa/spaces/cpgp1otrhrdm4hnytlv6.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818125/insite/qa/spaces/cpgp1otrhrdm4hnytlv6.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818125/insite/qa/spaces/cpgp1otrhrdm4hnytlv6.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 267,
    name: 'spaceTypes.serviceAreas.smallITRoom',
    displayOrder: 7,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(8.0, 6.0),
      [countries.UK]: getSize(8.0, 6.0),
      [countries.FR]: getSize(2.5, 4.5),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818131/insite/qa/spaces/tcnx69qnbeoz0xverzha.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818131/insite/qa/spaces/tcnx69qnbeoz0xverzha.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818131/insite/qa/spaces/tcnx69qnbeoz0xverzha.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818131/insite/qa/spaces/tcnx69qnbeoz0xverzha.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818131/insite/qa/spaces/tcnx69qnbeoz0xverzha.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 268,
    name: 'spaceTypes.serviceAreas.mailRoom',
    displayOrder: 8,
    spaceTypeId: spaceTypes.serviceareas.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(6.75, 5.2),
      [countries.EU]: getSize(3.0, 4.0),
      [countries.DE]: getSize(3.0, 4.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818133/insite/qa/spaces/pepkkbbvquch48zcok4a.png',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818133/insite/qa/spaces/pepkkbbvquch48zcok4a.png',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818133/insite/qa/spaces/pepkkbbvquch48zcok4a.png',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818133/insite/qa/spaces/pepkkbbvquch48zcok4a.png',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818133/insite/qa/spaces/pepkkbbvquch48zcok4a.png',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
